import ArrowDownIconDark from "~/assets/icons/ArrowDownIconDark";
import SearchIcon from "~/assets/icons/SearchIcon";
import { Breadcrumb, MenuItem } from "~/types";
import { header, navigationWithoutHover } from "../../../../setup/settings/index";
import useNavigation from "./useNavigation";
import { useEffect, useState } from "react";

type NavigationProps = {
  showCategory: string | boolean,
  shopSettings: any,
  setShowCategory: React.Dispatch<React.SetStateAction<string | boolean>>,
  mobile?: boolean,
  onClose?: () => void,
  menuItems: any[],
  css?: string,
  extraComponent?: JSX.Element
}

export default function Navigation({ showCategory, shopSettings, setShowCategory, mobile, onClose, menuItems, css, extraComponent }: NavigationProps) {

  const {
    getUrl,
    setBreadcrumb,
    onHover,
    onClick,
    disableInteractiveVendorList
  } = useNavigation({ shopSettings, mobile, onClose, setShowCategory, showCategory });

  if (mobile)
    return <MobileNavigation
      setBreadcrumb={setBreadcrumb}
      onClick={onClick}
      showCategory={showCategory}
      menuItems={menuItems}
      disableInteractiveVendorList={disableInteractiveVendorList}
      getUrl={getUrl}
    />
  else {
    return <DesktopNavigation
      css={css}
      setBreadcrumb={setBreadcrumb}
      onHover={onHover}
      showCategory={showCategory}
      menuItems={menuItems}
      disableInteractiveVendorList={disableInteractiveVendorList}
      getUrl={getUrl}
      extraComponent={extraComponent}
    />
  }
}

type DesktopNavigationProps = {
  css?: string,
  setBreadcrumb: (breadcrumb: Breadcrumb[]) => void,
  onHover: (handle: string) => void,
  showCategory: string | boolean,
  menuItems: MenuItem[],
  disableInteractiveVendorList: boolean,
  getUrl: (i: MenuItem) => string,
  extraComponent?: JSX.Element
}

function DesktopNavigation({ css, setBreadcrumb, onHover, showCategory, menuItems, disableInteractiveVendorList, getUrl, extraComponent }: DesktopNavigationProps) {
  
  const [baseUrl, setBaseUrl] = useState('');

  useEffect(() => {
    // Check if window is defined (running in the browser)
    if (typeof window !== 'undefined') {
      setBaseUrl(window.location.origin);
    }
  }, []);

  const externalUrl = (pc) => {
    if(getUrl(pc).charAt(0)=="/") return false;
    if(getUrl(pc).includes(baseUrl)) return false;
    else return true;
  }

  const [showMenu, setShowMenu] = useState(false);
  const [selectedPC, setSelectedPC] = useState<MenuItem | null>(null);

  const handleItemClick = (pc) => {
    if (selectedPC && pc.id === selectedPC.id) {
      setShowMenu(false);
      setSelectedPC(null);
    } else {
      setSelectedPC(pc);
      setShowMenu(true);
    }
    onHover(pc.handle);
  };
  
  const handleMouseLeave = () => {
    setShowMenu(false);
    setSelectedPC(null);
  };
  
  return (
    <div className={`topNavBar${css}`} onMouseLeave={navigationWithoutHover ? handleMouseLeave : () => null}>
      <div className={`topNavBar${css}__container`}>
        <ul className="site-nav list--inline" id="SiteNav">
          {menuItems.map((pc, i) => {
            const subCategories = pc.SubCategories;
            const itemNotClickeable = pc.customFields.headerCategoryOnlyNotClickable;

            return (
              <li key={i} className="site-nav__item site-nav--active rs-type-category inline-block" aria-haspopup="true">
                {!itemNotClickeable  /* ITEM CLICKEABLE*/ &&
                  <a target={externalUrl(pc)? "_blank" : undefined}  onMouseEnter={!navigationWithoutHover ? () => onHover(pc.handle) : () => null} href={`${getUrl(pc)}`}
                    onClick={() => setBreadcrumb([{ label: pc.name, handle: pc.handle }])}
                    className="site-nav__link site-nav__link-toggle" aria-expanded="false" aria-current="page">
                    {pc.name}
                    {subCategories != null && subCategories.length > 0 &&
                      <span className="menu-icon-arrow-down">
                        <ArrowDownIconDark classStyle={""} />
                      </span>
                    }
                  </a>}
                {itemNotClickeable  /* ITEM  NOT CLICKEABLE*/ &&
                  <div onMouseEnter={!navigationWithoutHover ? () => onHover(pc.handle) : () => null}
                    onClick={navigationWithoutHover ? ()=>handleItemClick(pc) : () => null}
                    className="site-nav__link site-nav__link-toggle" aria-expanded="false" aria-current="page" >
                    {pc.name}
                    {subCategories != null && subCategories.length > 0 &&
                      <span className="menu-icon-arrow-down">
                        <ArrowDownIconDark classStyle={""} />
                      </span>
                    }
                  </div>}
                {
                  navigationWithoutHover ?
                  <>
                    {showMenu && (
                      <>
                        {subCategories != null && subCategories.length > 0 &&
                          <div className={`site-nav__dropdown meganav site-nav__dropdown--second-level ${pc.handle != showCategory && 'hidden'}`}
                            role="navigation">
                            <ul className="meganav__nav page-width">
                              <div className="grid meganav__scroller--has-list">
                                <div className="grid__item meganav__list">
                                  <ListSubcategoriesDesktop subCategories={subCategories}
                                    setBreadcrumb={setBreadcrumb} pc={pc} getUrl={getUrl} externalUrl={externalUrl}/>
                                </div>
                              </div>
                            </ul>
                          </div>
                        }
                      </>
                    )}
                  </>
                  :
                  <>
                    {subCategories != null && subCategories.length > 0 &&
                      <div className={`site-nav__dropdown meganav site-nav__dropdown--second-level ${pc.handle != showCategory && 'hidden'}`}
                        role="navigation">
                        <ul className="meganav__nav page-width">
                          <div className="grid meganav__scroller--has-list">
                            <div className="grid__item meganav__list">
                              <ListSubcategoriesDesktop subCategories={subCategories}
                                setBreadcrumb={setBreadcrumb} pc={pc} getUrl={getUrl} externalUrl={externalUrl}/>
                            </div>
                          </div>
                        </ul>
                      </div>
                    }
                  </>
                }
              </li>
            )
          })}
          {!disableInteractiveVendorList &&
            <li key="41" className="site-nav__item site-nav--active rs-type-category inline-block" aria-haspopup="true">
              <a href="/brands" className="site-nav__link site-nav__link-toggle"
                aria-expanded="false" aria-current="page">
                <span>
                  Brands
                </span>
              </a>
            </li>
          }

          {header.searchInNavigation == true &&
            <li key="42" className="site-nav__item site-nav--active rs-type-category inline-block" aria-haspopup="true">
              <div className="searchInput">
                <form action={`/products`} method="GET">
                  <input name="search" className="border-transparent focus:border-transparent focus:ring-0" type="search" placeholder="Search..." />
                  <i className="fa fa-search">
                    <button type='submit'><SearchIcon /></button>
                  </i>
                </form>
              </div>
            </li>
          }
          {extraComponent && <li key="43" className="site-nav__item rs-type-category inline-block" aria-haspopup="true">{extraComponent}</li>}
        </ul>
      </div>
    </div>
  )
}

type MobileNavigationProps = {
  setBreadcrumb: (breadcrumb: Breadcrumb[]) => void,
  onClick: (handle: string, subCategories: MenuItem[]) => void,
  showCategory: string | boolean,
  menuItems: MenuItem[],
  disableInteractiveVendorList: boolean
  getUrl: (i: MenuItem) => string
}

function MobileNavigation({ setBreadcrumb, onClick, showCategory, menuItems, disableInteractiveVendorList, getUrl }: MobileNavigationProps) {
  return (
    <>
      {menuItems.map(pc => {
        const itemNotClickeable = pc.customFields.headerCategoryOnlyNotClickable;
        const subCategories = pc.SubCategories;
        return (
          <>
            {!itemNotClickeable  /* ITEM  CLICKEABLE*/ &&
              <div className="responsiveMenu__titleCategorie"
              >
                <a className="select-none cursor-pointer" href={`${getUrl(pc)}`}
                  onClick={() => setBreadcrumb([{ label: pc.name, handle: pc.handle }])}>
                  {pc.name}
                </a>
                {subCategories.length > 0 &&
                  <span onClick={() => onClick(pc.handle, subCategories)}
                    className={`${pc.handle == showCategory && 'rotate-180'} inline-block cursor-pointer ml-3`}>
                    <ArrowDownIconDark classStyle={""} />
                  </span>
                }
              </div>
            }
            {itemNotClickeable /* ITEM NOT CLICKEABLE*/ &&
              <div className="responsiveMenu__titleCategorie">
                <span className="select-none cursor-pointer" onClick={() => onClick(pc.handle, subCategories)}>
                  {pc.name}
                </span>
                {subCategories.length >0 &&
                  <>
                    <span onClick={() => onClick(pc.handle, subCategories)}
                      className={`${pc.handle == showCategory && 'rotate-180'} inline-block cursor-pointer ml-3`}>
                      <ArrowDownIconDark classStyle={""} />
                    </span>
                  </>
                }
              </div>
            }
            <div className="responsiveMenu__cointainerSubcategories">
              {subCategories.length > 0 && pc.handle == showCategory &&
                <>
                  <ListSubCategoriesMobile subCategories={subCategories} setBreadcrumb={setBreadcrumb} pc={pc} getUrl={getUrl} />
                </>
              }
            </div>
          </>
        )
      })}
      {!disableInteractiveVendorList &&
        <a className="responsiveMenu__titleCategorie" href="/brands">
          <span className="select-none cursor-pointer">
            Brands
          </span>
        </a>
      }
    </>
  )
}

type ListSubcategoriesProps = {
  setBreadcrumb: (breadcrumb: Breadcrumb[]) => void,
  subCategories: MenuItem[],
  pc: MenuItem,
  getUrl: (i: MenuItem) => string,
  externalUrl?: (i: MenuItem) => boolean,
}

function ListSubcategoriesDesktop({ setBreadcrumb, subCategories, pc, getUrl, externalUrl }: ListSubcategoriesProps) {

  return (
    <>
      {subCategories.map((sc: MenuItem, z: number) => {
        const subItemNotClickeable = sc.customFields.headerCategoryOnlyNotClickable;
        const subSubCategories = sc.SubCategories;

        return (
          <li key={z} className="site-nav__dropdown-container rs-type-category firstMenuContainer">
            {!subItemNotClickeable  /* ITEM CLICKEABLE*/ &&
              <a
              target={externalUrl(sc)?"_blank" : undefined}               
                onClick={() => setBreadcrumb([{ label: pc.name, handle: pc.handle }, { label: sc.name, handle: sc.handle }])} href={`${getUrl(sc)}`}
                className="meganav__link meganav__link--second-level meganav__link-toggle site-nav__link-toggle meganav__link--has-list meganav__link--active"
                aria-expanded="false" aria-current="page">
                {sc.name}
              </a>
            }
            {subItemNotClickeable   /* ITEM  NOT CLICKEABLE*/ &&
              <div
                className="meganav__link meganav__link--second-level meganav__link-toggle site-nav__link-toggle meganav__link--has-list meganav__link--active"
                aria-expanded="false" aria-current="page">
                {sc.name}
              </div>
            }

            {subSubCategories != null &&
              <ul className="meganav__list meganav__list--gutter">
                {subSubCategories.map((ssc: MenuItem, x: number) => {
                  const subSubItemNotClickeable = ssc.customFields.headerCategoryOnlyNotClickable;

                  return (

                    <li key={x} className="site-nav__dropdown-container site-nav__dropdown-container--third-level rs-type-category">
                      {!subSubItemNotClickeable  /* ITEM CLICKEABLE*/ &&
                        <a
                         target={externalUrl(ssc)?"_blank" : undefined} 
                          onClick={() => setBreadcrumb([{ label: pc.name, handle: pc.handle }, { label: sc.name, handle: sc.handle }, { label: ssc.name, handle: ssc.handle }])}
                          href={`${getUrl(ssc)}`}
                          className="meganav__link meganav__link--third-level">
                          {ssc.name}
                        </a>
                      }
                      {subSubItemNotClickeable  /* ITEM  NOT CLICKEABLE*/ &&
                        <div
                          className="meganav__link meganav__link--third-level">
                          {ssc.name}
                        </div>
                      }
                    </li>
                  )
                })}
              </ul>
            }
          </li>
        )
      })}
    </>
  );
}



function ListSubCategoriesMobile({ subCategories, setBreadcrumb, pc, getUrl }: ListSubcategoriesProps) {
  return (
    <>
      {subCategories.map((sc: MenuItem) => {
        const subItemNotClickeable = sc.customFields.headerCategoryOnlyNotClickable;
        const subSubCategories = sc.SubCategories;
        return (
          <>
            {!subItemNotClickeable /* ITEM CLICKEABLE*/ &&
              <span className="responsiveMenu__categoryLink">
                <a
                  className="select-none cursor-pointe link--second-level" href={`${getUrl(sc)}`}
                  onClick={() => setBreadcrumb([{ label: pc.name, handle: pc.handle }, { label: sc.name, handle: sc.handle }])}
                >
                  {sc.name}
                </a>
              </span>
            }
            {subItemNotClickeable /* ITEM  NOT CLICKEABLE*/ &&
              <div className="responsiveMenu__categoryLink">
                <span
                  className="select-none cursor-pointe link--second-level">
                  {sc.name}
                </span>
              </div>
            }
            {subSubCategories.length > 0 &&
              <>
                {subSubCategories.map((ssc: MenuItem) => {
                  const subSubItemNotClickeable = ssc.customFields.headerCategoryOnlyNotClickable;
                  return (
                    <>
                      {!subSubItemNotClickeable  /* ITEM  CLICKEABLE*/ &&
                        <a href={`${getUrl(ssc)}`}
                        >
                          <span className="select-none cursor-pointer link--third-level"
                            onClick={() => setBreadcrumb([{ label: pc.name, handle: pc.handle }, { label: sc.name, handle: sc.handle }, { label: ssc.name, handle: ssc.handle }])}>
                            {ssc.name}
                          </span>
                        </a>
                      }
                      {subSubItemNotClickeable  /* ITEM  NOT CLICKEABLE*/ &&
                        <a>
                          <span className="select-none cursor-pointer link--third-level">
                            {ssc.name}
                          </span>
                        </a>
                      }

                    </>
                  )
                })}
              </>
            }
          </>
        )
      })}
    </>
  )
}